<template>
    <div class="login-panel info-panel" v-if="beforeDate('2026-07-28')">
        <div class="info-text">
            <h4>
                <md-icon class="text-warning">info</md-icon>
            </h4>
            <b class="md-color-orange">Customer Notice</b>
            <p>The required downtime has now been completed and all platforms should be available.</p>
            <p>If you notice any odd behaviour then please inform the support team.</p>
            <p>Best wishes,<br />Navitas Safety Team</p>
        </div>
    </div>
</template>

<script>

    export default {
        name: "LoginNotice",
        methods: {
            beforeDate: function (to_date) {
                return (new Date()) < (new Date(to_date))
            },
            betweenDates: function (from_date, to_date) {
                return ((new Date()) >= (new Date(from_date))) && (new Date()) <= ((new Date(to_date)));
            },
        }
    }
</script>